import * as React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import bg from "../../assets/fons/background_fost.jpg";
import { ReactComponent as Simbol1 } from "../../assets/simbols/simbol1.svg";
import { animated, useSpring } from "react-spring";

export default function Header({ title, img, small, logo }) {
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:960px)");
    const baseRotate = matches ? -10 : 10;
    const swing = useSpring({
        from: { rot: baseRotate - 4 },
        to: { rot: baseRotate + 4 },
        loop: { reverse: true },
        reset: true,
        config: { duration: 2000 },
    });

    return (
        <Box className={classes.header}>
            <Box display="flex" justifyContent={"center"}>
                <Typography variant="h1" fontSize={110} textAlign="center">
                    {title}
                </Typography>

                <animated.div className={matches ? classes.simbol1 : classes.simbol1_m} style={{ transform: swing.rot.to((r) => `rotate(${r}deg)`) }}>
                    <Simbol1 className={classes.simbolSvg} />
                </animated.div>
            </Box>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    header: {
        // height: 40,
        background: `url(${bg})`,
        paddingTop: 200,
        paddingBottom: 20,
    },
    simbol1: {
        position: "absolute",
        top: 220,
        left: "40%",
        width: 150,
        fill: theme.color.secondary,
    },
    simbol1_m: {
        position: "absolute",
        top: 180,
        left: 20,
        width: 130,
        fill: theme.color.secondary,
    },
    simbolSvg: {
        width: "100%",
        height: "100%",
        fill: "inherit",
    },
}));
